var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class PrevNextCursor extends Component {
    constructor() {
        super('PrevNextCursor', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.compontent-prev-next-cursor').each((element) => {
                if ($(window).width() >= 992)
                    new Cursor(element);
            });
            this.success();
        });
    }
}
export class Cursor {
    constructor(element) {
        this.element = element;
        this.cursor = $.parseHTML('<div class="cursor d-none"></div>');
        this.element.append(this.cursor);
        this.element.on('mouseenter', () => {
            if (this.element.hasClass('compontent-prev-next-cursor-disabled'))
                return;
            this.cursor.removeClass('d-none');
        }).on('mouseleave', () => {
            this.cursor.addClass('d-none');
        }).on('mousemove', (event) => {
            if (this.element.hasClass('compontent-prev-next-cursor-disabled'))
                return;
            if ($(event.target).hasClass('carousel-caption') || event.target.tagName === 'A') {
                this.cursor.addClass('d-none');
            }
            else {
                this.cursor.removeClass('d-none');
            }
            const cursorPosition = this.getPosition(event);
            this.cursor.css({
                left: cursorPosition.x,
                top: cursorPosition.y
            });
            if (cursorPosition.x < this.element.width() / 2 && !this.element.hasClass('compontent-prev-next-cursor-next-only')) {
                this.cursor.addClass('cursor-prev').removeClass('cursor-next');
            }
            else {
                this.cursor.addClass('cursor-next').removeClass('cursor-prev');
            }
        });
    }
    getPosition(event) {
        return {
            x: event.pageX - this.element.position().x,
            y: event.pageY - this.element.position().y
        };
    }
}
